import React from "react"
import "./RadioGroup.scss"
import BaseField from "../Field/Base";
import Radio from "../Radio/Radio";
import { bem } from "../../helpers";
import PropTypes from "prop-types"
import FieldGroup from "../Field/Group";

export class RadioGroup extends FieldGroup {
  inputType="radio"

  onChange = (e) => {
    if (this.props && this.props.onChange) {
      this.props.onChange(e);
    } else if (this.props.propsForFields && this.props.propsForFields.onChange) {
      this.props.propsForFields.onChange(e);
    }
  }

  renderInput = () => {
    const {
      id,
      options,
      scrollable,
      propsForFields
    } = this.props
    
    return (
      <div className={bem("group", "radios", [scrollable && "scrollable"], this.props.className)}>
        {options.map( option => <Radio {...propsForFields} onChange={this.onChange} id={id} key={option.value} {...option} inputProps={{value: option.value}} /> )}
      </div>
    )
  }
}


RadioGroup.propTypes = {
  ...FieldGroup.propTypes,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any.isRequired,
    })
  )
}

export default RadioGroup